(function ($) {
    "use strict";
    $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function () {
        if (
            location.pathname.replace(/^\//, "") ==
                this.pathname.replace(/^\//, "")  &&
           ( location.hostname == this.hostname)
        ) {
            var target = $(this.hash);
            target = target.length
                ? target
                : $("[name=" + this.hash.slice(1) + "]");
            if (target.length) {
                var landed = false;
                $("html, body").animate(
                    {
                        scrollTop: target.offset().top - 70,
                    },
                    1000,
                    "easeInOutExpo",
                    function () {
                        if (landed) return;
                        landed = true;
                        // Images and lists above the target keep loading while the page scrolls, which moves the target
                        // and leaves the page just short of it (the menu then highlights nothing). Land exactly on it,
                        // then let scroll-spy re-measure so the clicked menu item is highlighted.
                        var again = target.offset().top - 70;
                        var settle = function () {
                            if (window.bwNav) bwNav.refreshSpy();
                            $(window).trigger("scroll");
                        };
                        if (Math.abs($(window).scrollTop() - again) > 4) {
                            $("html, body").animate({ scrollTop: again }, 300, settle);
                        } else {
                            settle();
                        }
                    }
                );
                return false;
            }
        }
    });
    $(".js-scroll-trigger").click(function () {
        if (window.bwNav) bwNav.hideMenu();
    });
    // scroll-spy and the menu collapse live in js/nav.js (the Bootstrap JavaScript bundle is no longer loaded)
    // The page's own menu item (aria-current, e.g. Search) shows the highlight bar only while no section item is
    // highlighted by scroll-spy, so exactly one item is highlighted at a time.
    var syncCurrent = function () {
        var sectionActive = $("#mainNav .nav-link.active").length > 0;
        $('#mainNav .nav-link[aria-current="page"]').toggleClass("is-current", !sectionActive);
    };
    var navbarCollapse = function () {
        if ($(window).scrollTop() > 100) {
            $("#mainNav").addClass("navbar-shrink");
        } else {
            $("#mainNav").removeClass("navbar-shrink");
        }
        syncCurrent();
    };
    navbarCollapse();
    $(window).scroll(navbarCollapse);
})(jQuery);
 let mybutton = document.getElementById("btn-back-to-top");
 window.onscroll = function() {
     if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
         mybutton.style.display = "block";
         setTimeout(() => {
             mybutton.classList.add('show');
         }, 10);
     } else {
         mybutton.classList.remove('show');
         setTimeout(() => {
             mybutton.style.display = "none";
         }, 300);
     }
 };
 mybutton.addEventListener("click", function() {
     window.scrollTo({
         top: 0,
         behavior: 'smooth'
     });
 });
  // decode the obfuscated e-mail address once, the first time it scrolls into view
  const emailtag = document.querySelector('.email-hidden.text-white');
  if (emailtag && 'IntersectionObserver' in window) {
    const emailObserver = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        if (typeof emaildecode === 'function') {
          emaildecode(entry.target);
          return;
        }
        const script = document.createElement('script');
        script.src = 'https://www.bwstays.com/js/decode-email.js';
        script.onload = function () {
          emaildecode(entry.target);
        };
        document.head.appendChild(script);
      });
    });
    emailObserver.observe(emailtag);
  }
// the WhatsApp chat button loads on the first scroll, tap or key press, or a few seconds after the page has loaded
function bwLoadWhatsapp() {
var url = 'https://wati-integration-prod-service.clare.ai/v2/watiWidget.js?65929';
var s = document.createElement('script');
s.type = 'text/javascript';
s.async = true;
s.src = url;
var options = {
"enabled":true,
"chatButtonSetting":{
	"backgroundColor":"#3f7f7b",
	"borderRadius":"3",
	"marginLeft": "10",
	"marginRight": "5",
	"marginBottom": "10",
	"ctaIconWATI":false,
	"position":"left"
},
"brandSetting":{
	"brandName":"Black and White Stays",
	"brandSubTitle":"Chat on WhatsApp",
	"brandImg":"https://www.bwstays.com/assets/img/icons/bw.svg",
	"welcomeText":"Hi there!\nHow can I help you?",
	"messageText":"Hello, %0A I have a question about {{page_link}}",
	"backgroundColor":"#3f7f7b",
	"ctaText":"Chat with bw Team",
	"borderRadius":"25",
	"autoShow":false,
	"phoneNumber":"99999 99999"
}
};
s.onload = function() {
	CreateWhatsappChatWidget(options);
};
var x = document.getElementsByTagName('script')[0];
x.parentNode.insertBefore(s, x);
}
(function () {
  var started = false;
  function start() {
    if (started) return;
    started = true;
    bwLoadWhatsapp();
  }
  ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function (e) { window.addEventListener(e, start, { passive: true, once: true }); });
  window.addEventListener('load', function () { setTimeout(start, 3500); });
})();
var iconURLPrefix = 'https://www.bwstays.com/';
var bwlocations = [['<h6><a id="bwlocation" target="_blank" href="https://www.bwstays.com" title="Black and White Stays">Black and White Stays</a></h6><a target="_blank" href="https://www.bwstays.com" title="Black and White Stays"><img title="Black and White Stays Service Villa"  alt="Black and White Stays Location Kalpetta"  src="https://www.bwstays.com/assets/img/logo/pin-drop.png" width="300" ></a>', 11.6057872, 76.0833109, 2, iconURLPrefix+"assets/img/logo/bw.png","Black and White Stays"]];
var element = document.getElementById('map');
var bwFooterMapReady = false;
// The footer map sits at the bottom of the page: create it (and fetch its tiles) only when it is about to be seen.
function bwInitFooterMap() {
  if (bwFooterMapReady || !element) return;
  if (typeof L === 'undefined') {
    // Leaflet is a lazy script on some pages: ask for it and try again shortly
    if (window.bwLoadLazy) window.bwLoadLazy();
    if ((bwInitFooterMap.tries = (bwInitFooterMap.tries || 0) + 1) < 50) setTimeout(bwInitFooterMap, 100);
    return;
  }
  bwFooterMapReady = true;
  var map = L.map(element,{ zoomControl: false });
  let customIcon = {
      iconUrl:"https://www.bwstays.com/assets/img/logo/pin.webp",
      iconSize:[40,40]
  }
  let myIcon = L.icon(customIcon);
  let iconOptions = {
      title:"BW Stays",
      icon:myIcon
  }
  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  }).on('tileload', function(e) {
      e.tile.alt = 'BW Stays Kalpetta';
  }).addTo(map);
  var target = L.latLng(bwlocations[0][1], bwlocations[0][2]);
  map.fitBounds([[11.6057872, 76.0833109], [11.610,76.090]]);
  map.setView(target, 14);
  L.marker(target,iconOptions).on('tileload', function(e) {
      e.tile.alt = 'All Locations at wayand';
  }).addTo(map).bindPopup( bwlocations[0][5]);
}
if (element) {
  if ('IntersectionObserver' in window) {
    var bwMapObserver = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) {
        bwMapObserver.disconnect();
        bwInitFooterMap();
      }
    }, { rootMargin: '600px 0px' });
    bwMapObserver.observe(element);
  } else {
    bwInitFooterMap();
  }
}
